import Table from "./src/Table.vue"
export default Table;
